<template lang="pug">
li.i_mt_sm_2(@mouseover="hover = true", @mouseleave="hover = false")
  a(@click="isExpand = !isExpand") {{ title }}
  ul.normal-sub(:class="[{ hover : hover }, { expand : isExpand }]")
    sublink(@hideSubMenu="hideSubMenu", v-for="(item, index) in list", :subLink="item", :key="index")
</template>

<script>
import Sublink from "@/components/common/Navigation/Sublink";

export default {
  name: "Link",
  data() {
    return {
      hover: false,
      isExpand: false,
    };
  },
  props: {
    title: String,
    list: Array,
  },
  components: {
    sublink: Sublink,
  },
  methods: {
    hideSubMenu() {
      this.hover = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/link";
</style>
